var __WEBPACK_NAMESPACE_OBJECT__ = I18n;